var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefusedXxs({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 0a46 46 0 1046 46A46.054 46.054 0 0046 0zm0 83.636A37.636 37.636 0 1183.636 46 37.683 37.683 0 0146 83.636z",
    fill: "url(#refused-xxs_svg__paint0_linear_7971_99442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.535 24.965a5 5 0 10-7.07 7.07l7.07-7.07zm32.93 47.07a5 5 0 107.07-7.07l-7.07 7.07zm-40-40l40 40 7.07-7.07-40-40-7.07 7.07z",
    fill: "url(#refused-xxs_svg__paint1_linear_7971_99442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.535 72.035a5 5 0 11-7.07-7.07l7.07 7.07zm32.93-47.07a5 5 0 117.07 7.07l-7.07-7.07zm-40 40l40-40 7.07 7.07-40 40-7.07-7.07z",
    fill: "url(#refused-xxs_svg__paint2_linear_7971_99442)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "refused-xxs_svg__paint0_linear_7971_99442",
    x1: -46,
    y1: 46,
    x2: 46,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "refused-xxs_svg__paint1_linear_7971_99442",
    x1: 5,
    y1: 48.5,
    x2: 45,
    y2: 88.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "refused-xxs_svg__paint2_linear_7971_99442",
    x1: 5,
    y1: 48.5,
    x2: 45,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72828"
  })))));
}

export default SvgRefusedXxs;